import { css, SerializedStyles } from '@emotion/react';
import { Theme } from '@shipengine/giger-theme';

export const otherBenefitsStyles = (theme: Theme): SerializedStyles =>
    css({
        'label:not(:last-child)': {
            marginBottom: theme.spacing(),
        },
    });
